import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store";
import {
  logoutUserSuccess,
  ACCESS_TOKEN_KEY,
} from "../auth/store/login/reducer";
import SplashScreen from "../../components/common/SplashScreen";
import { fetchProfile } from "./store/login/thunk";
import useOrganization from "../organization/hooks/useOrganization";
import { useProfile } from "./hooks/useProfile";

interface Props {
  children: React.ReactNode;
}

export default function AuthBootstrap({ children }: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const { profileLoading, isCoach } = useProfile();
  const { isCoachDomain } = useOrganization();

  useEffect(() => {
    const token = localStorage.getItem(ACCESS_TOKEN_KEY);

    if (!token) {
      dispatch(logoutUserSuccess());
      return;
    }

    if (isCoach && !isCoachDomain) {
      dispatch(logoutUserSuccess());
      return;
    }

    dispatch(fetchProfile());
  }, [dispatch, isCoach, isCoachDomain]);

  if (profileLoading) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
